export default __webpack_public_path__ + "static/media/oruga.43d8295f.png";